import axios from 'axios';
import { useMutation } from '@tanstack/react-query';

import { TypeMaster } from 'models/type/TypeMaster';

export function useDeleteWorkflowTypeMaster() {
    return useMutation({
        mutationFn: (request: TypeMaster) => {
            const accessToken = localStorage.getItem('WF_APPLICATION');

            return axios.delete('/v2/configuration/workflow/type', {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                params: {
                    sid: request.sid,
                    id: request.workflowtypeid
                }
            });
        }
    });
}
